import { Skeleton } from "@/components/ui/skeleton";

interface AuthResolveSkeletonProps {
  message?: string;
}

/**
 * Minimal shell while auth/session checks resolve.
 * Intentionally not dashboard-shaped — a sidebar+cards skeleton made hard refresh
 * feel like a bounce through Dashboard on every protected route.
 */
export function AuthResolveSkeleton({
  message = "Verifying your account...",
}: Readonly<AuthResolveSkeletonProps>) {
  return (
    <div
      className="flex min-h-screen w-full items-center justify-center bg-white p-6"
      aria-busy="true"
      aria-label={message}
    >
      <div className="w-full max-w-sm space-y-4 text-center">
        <Skeleton className="mx-auto h-10 w-40" />
        <Skeleton className="mx-auto h-4 w-56" />
        <Skeleton className="mx-auto h-4 w-44" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
}
